export default "empty-content .empty-content {\n  display: grid;\n  place-items: center;\n}";